"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var channel_1 = __importDefault(require("./channel"));
var Channels = /** @class */ (function () {
    function Channels(virtualSocket) {
        this.virtualSocket = virtualSocket;
        this.channelsList = [];
    }
    Channels.prototype.add = function (name, resourceId, info) {
        var maybeChannel = this.find(name, resourceId);
        if (maybeChannel) {
            return maybeChannel;
        }
        var channel = new channel_1.default(this.virtualSocket, name, resourceId, info);
        this.channelsList.push(channel);
        return channel;
    };
    Channels.prototype.remove = function (name, resourceId) {
        var channel = this.find(name, resourceId);
        this.channelsList = this.channelsList.filter(function (c) { return c.name !== name || c.resourceId !== resourceId; });
        return channel;
    };
    Channels.prototype.find = function (name, resourceId) {
        return this.channelsList.find(function (c) { return c.name === name && c.resourceId === resourceId; });
    };
    Channels.prototype.all = function () {
        return this.channelsList;
    };
    Channels.prototype.subscribeAll = function () {
        this.all().forEach(function (c) { return c.subscribe(); });
    };
    Channels.prototype.setUnsubscribeAll = function () {
        this.all().forEach(function (c) { return c.setUnsubscribe(); });
    };
    return Channels;
}());
exports.default = Channels;
//# sourceMappingURL=channels.js.map